import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {EmpleadoSemanaModel} from '../../FriedmanModule/models/empleado.semana.model';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {CargoEntity} from '../../CoreModule/entities/cargo.entity';
import * as moment from 'moment';

export class EmpleadoReporteModel {
  _id: any;
  empleado: EmpleadoModel;
  ventas: any[] = [];
  mallas: EmpleadoSemanaModel[] = [];

  tiendas: TiendaEntity[] = [];
  cargo: CargoEntity;

  meta: number = 0;
  minimo: number = 0;
  venta: number = 0;
  artTicket: number = 0;
  ticketPromedio: number = 0;
  cumplimiento: number = 0;
  friedman:number = 0;

  dataGraficas: any = {};
  view: any[] = [700, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Ventas';
  showYAxisLabel = true;
  yAxisLabel = 'En Pesos';
  timeline = true;

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };


  crearEmpleadoReporte(data: any) {
    console.log(data);

    this._id = data._id;
    this.empleado = data.empleado;
    if (data.ventas)
      this.ventas = data.ventas;
    if (data.mallas)
      this.mallas = data.mallas;

    if (data.tiendas)
      this.tiendas = data.tiendas;
    this.cargo = data.cargo;

  }

  calcularIndicadores(fecha1: any, fecha2: any) {
    this.meta = 0;
    this.mallas.map(ma => {

      for (let m of ma.meta) {

        let f = moment(m.fecha);
        if (moment(f).isBetween(fecha1, fecha2, undefined,"[]"))
          this.meta += m.metaDia;
      }
    });

    this.venta = 0;
    this.artTicket = 0;

    // falta validar notas credito
    this.ventas.map(v => {
      this.venta += v.cantidad;
      this.artTicket += v.articulos.length;
    });

    if (this.artTicket > 0)
      this.artTicket /= this.ventas.length;

    if(this.venta > 0)
      this.ticketPromedio = this.venta/ this.ventas.length;

    this.minimo = this.meta * .9;
    this.cumplimiento = this.venta / this.meta * 100;

    if (this.cumplimiento <= 89.99)
      this.friedman = 0;
    else if (this.cumplimiento <= 99.99)
      this.friedman = 1;
    else if (this.cumplimiento <= 109.99)
      this.friedman = 2;
    else
      this.friedman = 3;

    this.dataGraficas = {
      'name': this.empleado.nombre,
      'series': [
        {
          'name': 'Presupuesto',
          'value': this.meta
        },
        // {
        //   'name': 'Minimo',
        //   'value': this.minimo
        // },
        {
          'name': 'Ventas Actuales',
          'value': this.venta
        }
      ]
    };
  }


}


